<script setup lang="ts">
defineProps<{
    title?: string
    description?: string
    items?: MenuItem[]
}>()

const [isOpen, toggle] = useToggle(false)
</script>
    
<template>
    <div class="z-1">
        <slot name="trigger" :toggle="toggle" :title="title">
            <button class="h-full align-middle" type="button" @click="toggle()">
                <slot name="trigger-content">
                    {{ title }}
                </slot>
            </button>
        </slot>

        <TransitionRoot appear :show="isOpen" as="template">
            <Dialog as="div" @close="toggle(false)">
                <div class="fixed inset-0 z-10 overflow-y-auto">
                    <div class="flex h-screen flex-col justify-end">
                        <TransitionChild
                            as="template"
                            enter="duration-300 ease-out"
                            enter-from="opacity-0"
                            enter-to="opacity-100"
                            leave="duration-200 ease-in"
                            leave-from="opacity-100"
                            leave-to="opacity-0"
                        >
                            <DialogOverlay class="fixed inset-0 bg-black/75" />
                        </TransitionChild>

                        <TransitionChild
                            as="template"
                            enter="duration-300 ease-out"
                            enter-from="opacity-0 translate-y-[200px]"
                            enter-to="opacity-100 translate-y-0"
                            leave="duration-200 ease-in"
                            leave-from="opacity-100 translate-y-0"
                            leave-to="opacity-0 translate-y-full"
                        >
                            <div
                                class="pointer-events-auto w-full transform bg-neutral px-6 pb-2 pt-6 shadow-xl transition-all"
                            >
                                <DialogTitle
                                    v-if="title"
                                    as="h3"
                                    class="text-lg font-medium leading-6 text-black"
                                >
                                    {{ title }}
                                </DialogTitle>

                                <DialogDescription
                                    v-if="description"
                                    class="text-gray-500 mt-2 text-sm"
                                >
                                    {{ description }}
                                </DialogDescription>

                                <div
                                    tabindex="1"
                                    class="my-4 grid grid-cols-1 gap-2 md:grid-cols-2 md:gap-4 lg:grid-cols-3 lg:gap-6"
                                >
                                    <slot name="before-items" />

                                    <slot :items="items" :toggle="toggle">
                                        <UiMenuDialogItem
                                            v-for="(item, index) in items"
                                            :key="index"
                                            :item="item"
                                            @close="toggle(false)"
                                        />
                                    </slot>
                                    <slot name="after-items" />
                                </div>
                            </div>
                        </TransitionChild>
                    </div>
                </div>
            </Dialog>
        </TransitionRoot>
    </div>
</template>